export class InvestigationAssigneeCandidateEntity {
  public userId!: string;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public isManager!: boolean;
  public teamIds!: string[];
}
